<template>
  <header 
    :class="[`scroll-${sd}`, 
    subList ? 'has-sub' : '']">
    <div class="bar" :class="{ 'nav-open': navState, 'nav-closing': navClosing }">
      <router-link to="/" class="logo">데이터센터 각</router-link>
      <nav @click.exact="closeNav">
        <div class="drawer" @transitionend="drawerTransitionEnd" @click.stop :style="{ height }">
          <a class="drawer-close" @click="closeNav" />
          <div class="scroll-body">
            <ul class="nav">
              <li v-if="sect === 'sm' || sect === 'md'">
                <router-link to="/">Home</router-link>
              </li>
              <li v-for="depth1 in nav" :key="depth1.route" :class="depth1.isDisabled ? 'is-disabled' : null">
                <router-link :to="`/${depth1.route}`" :class="depth1.class">{{
                  depth1.label
                }}</router-link>
                <ul>
                  <li v-for="depth2 in filterNoNav(depth1.children)" :key="depth2.route">
                    <router-link :to="`/${depth1.route}/${depth2.route}`" v-html="depth2.label"
                      :class="depth2.isDisabled ? 'is-disabled' : null" />
                  </li>
                </ul>
              </li>
            </ul>
            <div class="utils">
              <a class="go-link" href="https://www.ncloud.com/" target="_blank">네이버 클라우드 바로가기</a>
              <div class="lang" :class="{ on: toggle }" @click="openLang">
                <button class="btn-lang">언어</button>
                <ul class="list">
                  <li>
                    <button @click="setLang('kr')" :class="{ on: lang === 'kr' }">
                      KOR
                    </button>
                  </li>
                  <li>
                    <button @click="setLang('en')" :class="{ on: lang === 'en' }">
                      ENG
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div class="depth1-name" v-if="subList">
        <s>{{ $route.meta.depth1.label }}</s>
      </div>
      <div class="depth1-name" v-else-if="$route.meta.main">
        <s></s>
      </div>
      <a class="switcher" @click="openNav" />
    </div>
    <div class="sub-bar" v-if="subList" :class="{ dark: $route.meta.dark }">
      <ul>
        <li v-for="subItem in subList" :key="subItem.route">
          <router-link :to="`/${$route.meta.depth1.route}/${subItem.route}`"
            :class="subItem.isDisabled ? 'is-disabled' : null">
            <s v-html="subItem.label" />
            <i v-html="subItem.label" />
          </router-link>
        </li>
      </ul>
      <s class="stick" :style="{ width: stickWidth, left: stickLeft }" />
    </div>
    <div class="sub-bar" v-else-if="$route.meta.main" :class="{ dark: $route.meta.dark }"></div>
  </header>
</template>

<script>
import _ from "lodash";
import nav from "@/data/nav";
import { setCookie, getCookie } from "@/utils";

export default {
  name: "AppHeader",
  data() {
    return {
      nav,
      navClosing: false,
      stickWidth: 0,
      stickLeft: "50%",
      height: "100vh",
      dir: "up",
      dirHold: false,
      toggle: false,
      currentLang: this.getCurrentLang(),
    };
  },
  watch: {
    $route: "routed",
    sdir(val) {
      if (val === "up") {
        if (this.dir === "down") {
          this.dir = "up";
          this.dirHold = true;
          setTimeout(() => {
            this.dirHold = false;
            this.dir = "down";
          }, 2000);
        }
      } else {
        if (!this.dirHold) this.dir = "down";
      }
    },
  },
  computed: {
    sd() {
      if (this.sv <= 64) return "up";
      return this.dir;
    },
    subList() {
      if (!this.$route.meta || !this.$route.meta.depth1) return null;
      const depth1 = _.find(
        nav,
        (row) => row.route === this.$route.meta.depth1.route
      );
      return depth1 ? this.filterNoNav(depth1.children) : null;
    },
    navState() {
      return this.$store.state.nav;
    },
  },
  methods: {
    filterNoNav(list) {
      return _.filter(list, (depth2) => !depth2.noNav);
    },
    openNav() {
      this.$el.querySelector(".scroll-body").scrollTop = 0;
      this.$store.commit("openNav");
    },
    closeNav() {
      if (this.navState) this.navClosing = true;
    },
    openLang() {
      this.toggle = !this.toggle;
    },
    routed() {
      this.closeNav();
      this.stickUpdate();
    },
    drawerTransitionEnd() {
      if (this.navClosing) {
        this.$store.commit("closeNav");
        this.navClosing = false;
      }
    },
    stickUpdate() {
      if (this.$el) {
        this.$nextTick(() => {
          const subItem = this.$el.querySelector(
            ".sub-bar .router-link-active"
          );
          if (subItem) {
            this.stickWidth = `${subItem.offsetWidth}px`;
            this.stickLeft = `${subItem.offsetLeft}px`;
          } else {
            this.stickWidth = 0;
            this.stickLeft = "50%";
          }
        });
      }
    },
    resized() {
      this.stickUpdate();
      this.heightUpdate();
    },
    heightUpdate() {
      this.height = `${window.innerHeight}px`;
    },
    setLang(lang) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.delete('lang');
      const newUrl = `${window.location.pathname}`;

      window.location.href = newUrl;
      setCookie("gak-lang", lang);
    },
    setLangPage(lang) {
      if (lang === this.currentLang) {
        return;
      }
      setCookie("gak-lang", lang);
      window.location.reload();
    },
    getCurrentLang() {
      return getCookie('gak-lang') || 'kr';
    }
  },
  mounted() {
    setTimeout(this.stickUpdate, 300);
    if (this.$el) {
      window.addEventListener("resize", _.debounce(this.resized, 100));
      window.addEventListener("resize", this.heightUpdate);
      this.heightUpdate();
    }

    const urlParams = new URLSearchParams(location.search);
    const paramLang = urlParams.get('lang');
    
    if (paramLang && paramLang === 'en') {
      this.setLangPage(paramLang);
    } else if (paramLang && paramLang !== 'en') {
      this.setLangPage('kr');
    }
  },
};
</script>

<style lang="less">
@import "~@/less/proj";

header {
  .calibre;

  .bar {
    .p(16, 53, 14);
    .rel;
    .tc;
    .-box;
    .h(64);
    .bgc(#131313);

    .logo {
      .block;
      .ir;
      .abs;
      .wh(36);
      .bg-contain("@{common}/logo.svg");
      .no-repeat;
      .lt(20, 14);
    }

    .nav {
      li {
        &.is-disabled {

          a {
            pointer-events: none;
          }
        }

        a {
          &.outlink {
            .rel;

            &::before {
              .abs;
              .cnt;
              .rt(-21, 50%);
              .wh(16);
              .mt(-3);
              .yc;
              .bg-contain("@{common}/ico-link_mo.svg");
              .no-repeat;
            }
          }
        }

        ul li a {
          &.is-disabled {
            color: @c-disabled-gray3 !important;
            pointer-events: none;
          }
        }
      }
    }
  }

  .sub-bar {
    ul li a {
      &.is-disabled {
        opacity: 0.4;
        pointer-events: none;
      }
    }
  }
}

@media (max-width: @screen-md-max) {

  // 해상도 ~ 767 이하
  header {
    .fix;
    .wf;
    .lt;
    z-index: 100;
    transition: top 0.3s;

    .bar {
      .depth1-name {
        .fs(20);
        .semi-bold;
        .lh(33);
        color: #fff;

        s {
          .cal-m;
        }
      }

      .switcher {
        .block;
        .wh(28);
        .bg-contain("@{common}/switcher.svg");
        .abs;
        .rt(18, 18);
      }

      nav {
        .fix;
        .rt(-100vw, 0);
        z-index: 20;

        &:before {
          .cnt;
          .block;
          .wh(100vw, 100vh);
          .bgc(rgba(0, 0, 0, 0.7));
          opacity: 0;
          .abs;
          .rt;
          transition: opacity 0.5s;
        }

        .drawer {
          .wh(281, 100vh);
          .bgc(#fff);
          .abs;
          .rt(-281, 0);
          transition: right 0.5s;
          .tl;

          .drawer-close {
            .wh(28, 28);
            .bg-contain("@{common}/drawer-close.svg");
            .abs;
            .rt(20, 20);
          }

          .scroll-body {
            .f;
            .p(21, 24, 34);
            .-box;
            overflow: auto;
            font-size: 0;

            .nav {
              >li {
                .gap-v(30);

                >a {
                  .fs(14);
                  color: #9e9e9e;
                  .medium;
                }

                &:first-child {
                  >a {
                    .fs(18, 1.33);
                    color: #333;

                    &.router-link-exact-active {
                      color: @c-light-blue;
                    }
                  }
                }

                &.is-disabled {
                  a {
                    &::before {
                      opacity: 0.6;
                    }
                  }
                }

                ul {
                  .mt(8);

                  li {
                    .gap-v(8);

                    a {
                      .fs(18, 1.33);
                      color: @c-light-black;
                      .medium;

                      &.router-link-active {
                        color: @c-light-blue;
                      }
                    }
                  }
                }
              }
            }

            .utils {
              .flex;
              flex-direction: column;
              justify-content: space-between;
              min-height: calc(100vh - 678px);
              .mt(12);
              font-size: 0;

              .go-link {
                .ib;
                .ir;
                .wh(196, 20);
                .bg-contain("@{common}/naver-cloud-logo_mo.png");
                .no-repeat;
              }

              .lang {
                .flex;
                align-items: center;
                .mt(12);

                .btn-lang {
                  .ib;
                  .ir;
                  .wh(28);
                  .bg-contain("@{common}/ico-lang_black.svg");
                  .no-repeat;
                }

                .list {
                  .flex;
                  .ml(10);

                  >li {
                    .rel;
                    .gap-h(13);

                    &:first-child::before {
                      .hide;
                    }

                    &::before {
                      .cnt;
                      .abs;
                      .lt(-6, 50%);
                      .yc;
                      .wh(1, 9);
                      .mt(-3);
                      .bgc(#eee);
                    }

                    button {
                      .calibre;
                      .medium();
                      .fs(14);
                      color: @c-disabled-gray3;

                      &.on {
                        color: @c-light-black;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      &.nav-open {
        nav {
          .rt;

          &:before {
            opacity: 1;
          }

          .drawer {
            .r(0);
          }
        }
      }

      &.nav-closing {
        nav {
          &:before {
            opacity: 0;
          }

          .drawer {
            .r(-281);
          }
        }
      }
    }

    .sub-bar {
      .-t(#424242);
      .rel;
      .bgc(#131313);
      color: #fff;

      ul {
        .ib-list;
        .tc;

        li {
          .gap-h(16);

          a {
            .ib;
            .rel;
            .h(55);
            .fs(18);

            br {
              .hide;
            }

            i {
              .abs;
              .lt;
              .h(55);
              .lh(55);
              .f;
              .tc;
              .cal-m;
            }

            s {
              .ib;
              .semi-bold;
              .h(55);
              .lh(55);
              opacity: 0;
            }

            &.router-link-active i {
              .semi-bold;
              color: @c-blue;
            }
          }
        }
      }

      .stick {
        .block;
        .wh(0, 2);
        .bgc(@c-blue);
        .abs;
        .lb;
        transition: width 0.3s, left 0.3s;
      }
    }

    &.has-sub.scroll-down {
      .t(-64);
    }
  }
}

@media (min-width: @screen-md-min) and (max-width: @screen-md-max) {

  // 해상도 768 이상 ~ 1023 이하
  header {
    .bar {
      nav .drawer {
        .w(384);
        .r(-384);

        .scroll-body {
          .p(21, 25, 19);

          .nav {
            >li {
              .gap-v(45);

              ul {
                .mt(10);

                li {
                  .gap-v(10);
                }
              }
            }
          }

          .utils {
            min-height: calc(100vh - 763px);
            .mt(15);

            .lang {
              .flex;
              align-items: flex-end;
              .mt(15);

              .btn-lang {
                .wh(24);
              }

              .list {
                .ml(8);
              }
            }
          }
        }
      }

      &.nav-closing {
        nav .drawer {
          .r(-384);
        }
      }
    }

    .sub-bar {
      ul li {
        .gap-h(20);
      }
    }
  }
}

@media (min-width: @screen-lg-min) {

  // 해상도 1024 이상 ~ 1359 이하
  header {
    color: #fff;

    .bar {
      .p(0, 180);
      .fix;
      .wf;
      .lt;
      z-index: 10;

      .logo {
        .bg-contain("@{common}/logo-label.svg");
        .wh(128, 30);
        .lt(40, 17);

        .en & {
          .bg-contain("@{common}/logo-label.en.svg");
          .wh(164, 30);
        }
      }

      nav {
        .drawer {
          height: auto !important;
        }

        .nav {
          .ib-list;

          >li {
            .rel;
            .lh(33);
            .medium;
            .p(14, 40, 8, 0);
            margin: 0;

            &:first-child {
              .ml(35);
            }

            &::before {
              .cnt;
              .hide();
              .abs();
              .lb(0, 0);
              .wh(100%, 5);
              .bgc(@c-blue);
            }

            &.is-disabled {
              >a {
                color: @c-disabled-gray;
                pointer-events: none;
              }

              &:hover {
                &::after {
                  height: 0 !important;
                }

                >a {
                  color: @c-disabled-gray !important;
                }

                >ul {
                  visibility: hidden !important;
                  opacity: 0 !important;
                }
              }
            }

            >a {
              .pb(5);
              .fs(18);
              .cal-m;
              .rel;
              .-b(transparent, 5);

              &:after {
                .hide !important;
                .cnt;
                .wh(0, 5);
                .bgc(@c-blue);
                .lb(50%, -11);
                .abs;
                transform: translateX(-50%);
                transition: width 0.3s;
              }

              &.router-link-active {
                color: @c-blue;
                border-bottom-color: @c-blue;

                &:after {
                  width: 100%;
                }
              }

              &.outlink {
                &::before {
                  .hide;
                }
              }
            }

            &:after {
              .cnt;
              .fix;
              .lt(0, 63);
              .wh(100%, 0);
              background: #2c3037;
              transition: height 0.3s;
            }

            >ul {
              .hidden;
              .abs;
              .lt(0, 65);
              .ib-list;
              .nowrap;
              z-index: 5;
              opacity: 0;
              transition: opacity 0.3s;
              transition-delay: 0.1s;

              li {
                .fs(18, 54, 0);

                a {
                  .rel;

                  &:after {
                    .cnt;
                    .wh(0, 2);
                    .bgc(#fff);
                    .lb(50%, 0);
                    .abs;
                    transform: translateX(-50%);
                    transition: width 0.3s;
                  }

                  &.is-disabled {
                    color: @c-disabled-gray2 !important;

                    &:after {
                      .bgc(transparent);
                    }
                  }
                }

                .router-link-active,
                .no-touch &:hover a {
                  &:after {
                    .wf;
                  }
                }
              }

              li+li {
                .ml(40);
              }
            }

            .no-touch &:hover {
              >a {
                color: @c-blue;
              }

              &:after {
                .h(54);
              }

              >ul {
                .visible;
                opacity: 1;
              }
            }
          }
        }

        .utils {
          .flex();
          align-items: center;
          .abs;
          .rt(0, 0);
          .p(18, 40, 18, 0);

          .go-link {
            .ib;
            .ir;
            .wh(186, 28);
            .bg-contain("@{common}/naver-cloud-logo.png");
            .no-repeat;

            &:hover {
              .bg("@{common}/naver-cloud-logo_on.png");
            }
          }

          .lang {
            .rel();
            .ml(15);

            &.on {
              .btn-lang {
                .bg("@{common}/ico-lang_on.svg");
              }

              .list {
                .block;
              }
            }

            .btn-lang {
              .ib;
              .ir;
              .wh(24);
              .bg-contain("@{common}/ico-lang.svg");
              .no-repeat;

              &:hover {
                .bg("@{common}/ico-lang_on.svg");
              }
            }

            .list {
              .hide;
              .abs();
              .rt(0, 24);
              z-index: 10;
              .mt(19);
              .p(13);
              .-a(#424242, 1px);
              .bgc(#131313);

              li {
                .gap-v(4);
              }

              button {
                .flex();
                align-items: center;
                justify-content: center;
                .wh(83, 36);
                .pt(7);
                .medium();
                .calibre;
                .fs(16);
                color: #fff;
                .br(3);

                &:hover {
                  .bgc(@c-blue);
                }
              }
            }
          }
        }
      }

      .depth1-name {
        .hide;
      }

      .switcher {
        .hide;
      }
    }

    .sub-bar {
      .fix;
      z-index: 1;
      .lt;
      transition: left 0.5s;
      color: #999999;

      ul {
        .p(104, 0, 0, 40);

        li {
          .gap-v(5);

          a {
            .block;

            i {
              .fs(20);
              .lh(26);
              .medium;
              .rel;
              .ib;
              .mb(5);

              br {
                .block;
              }

              &:after {
                .cnt;
                .wh(0, 2);
                .lb(50%, 0.25em);
                .abs;
                .block;
                background: @c-blue;
                transform: translateX(-50%);
                transition: width 0.3s;
              }
            }

            s {
              .hide;
            }

            &.router-link-active {
              color: @c-blue;

              i:after {
                .wf;
              }

              /* i { .underline; } */
            }
          }
        }
      }

      /*&.dark { color: #fff; }*/
    }

    &.scroll-down .sub-bar {
      .l(-25%);
    }
  }
}

@media (min-width: @screen-xl-min) {

  // 해상도 1360 이상 ~
  header {
    .bar {
      .logo {
        .en & {
          .bg-contain("@{common}/logo-label.en.svg");
          .wh(186, 30);
        }
      }

      nav {
        .nav {
          >li {
            .p(16, 90, 6, 0);

            &:first-child {
              .ml(80);
            }

            >a {
              &.router-link-active {
                .medium;
                color: @c-blue;
              }
            }
          }
        }

        .utils {
          .p(12, 40, 12, 0);

          .go-link {
            .wh(272, 40);
          }

          .lang {
            .ml(20);

            .list {
              button {
                .wh(86, 40);
                .fs(18);
              }
            }
          }
        }
      }
    }
  }
}
</style>
